window.addEventListener('alpine:init', () => {
  function video(data = {}) {
    return {
      ...data,

      refs: {
        ...this.refs,
        video: this.$el.querySelector('[x-ref="video"]'),
        iframe: this.$el.querySelector('[x-ref="iframe"]')
      },

      isActiveVideo: data.isActiveVideo ?? false,

      onIntersectLeave() {
        if (this.refs.video) {
          this.refs.video.pause();
        }

        if (this.refs.iframe) {
          this.refs.iframe.src = this.refs.iframe.src.replace('autoplay=1', 'autoplay=0');
        }

        if (!data.isAutoplayVideo) {
          this.isActiveVideo = false;
        }
      },

      onIntersectEnter() {
        if (this.refs.video) {
          this.refs.video.play();
        }

        if (this.refs.iframe) {
          this.refs.iframe.src = this.refs.iframe.src.replace('autoplay=0', 'autoplay=1');
          this.refs.iframe.removeAttribute('loading');
        }
      },

      onClickVideoButton() {
        this.isActiveVideo = !this.isActiveVideo;
      }
    };
  };

  Alpine.data('video', video);
});
